var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56435 5.37395L5.98573 6.79534L10.7237 2.05738",
    stroke: "#BDBABB",
    strokeWidth: 0.947592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2498 5.84773V9.1643C10.2498 9.41562 10.15 9.65665 9.97228 9.83435C9.79457 10.0121 9.55355 10.1119 9.30223 10.1119H2.66909C2.41777 10.1119 2.17675 10.0121 1.99904 9.83435C1.82133 9.65665 1.7215 9.41562 1.7215 9.1643V2.53116C1.7215 2.27984 1.82133 2.03882 1.99904 1.86111C2.17675 1.6834 2.41777 1.58357 2.66909 1.58357H7.88084",
    stroke: "#BDBABB",
    strokeWidth: 0.947592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3711,
    height: 11.3711,
    fill: "white",
    transform: "translate(0.300171 0.16217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.47640311089135a3c5307aa2e3cdedb2.svg";
export { ForwardRef as ReactComponent };